<div>
    @if (metricsLoadError) {
        <div class="alert alert-warning py-2 small" role="alert">Dashboard metrics could not be loaded. Try refreshing the page.</div>
    }

    <div class="row g-3 mb-3">
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Incidents this month</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.incidentsThisMonth }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Incidents YTD</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.incidentsYearToDate }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-danger border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Injuries YTD</div>
                    <div class="fs-3 fw-semibold text-danger">{{ metrics.kpi.injuriesYearToDate }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-warning border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Near misses YTD</div>
                    <div class="fs-3 fw-semibold text-warning">{{ metrics.kpi.nearMissesYearToDate }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3 mb-3">
        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Incidents by month</h5>
                    <p class="small text-muted">Submitted incidents over the last 12 months.</p>
                    @if (metrics.monthlyCounts.length === 0) {
                        <p class="text-muted small mb-0">No submitted incidents in this period.</p>
                    } @else {
                        <div class="d-flex align-items-end gap-1 ii-bar-wrap">
                            @for (m of metrics.monthlyCounts; track m.label) {
                                <div class="flex-fill text-center">
                                    <div class="ii-bar rounded-top" [style.height.px]="(m.count / maxMonthlyCount()) * 120 || 4" [title]="m.label + ': ' + m.count"></div>
                                    <div class="small text-muted mt-1">{{ m.label }}</div>
                                    <div class="small fw-semibold">{{ m.count }}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">By incident type (YTD)</h5>
                    <p class="small text-muted">Submitted incidents grouped by type for the current year.</p>
                    @if (metrics.incidentTypeCounts.length === 0) {
                        <p class="text-muted small mb-0">No submitted incidents recorded yet.</p>
                    } @else {
                        <div class="d-flex align-items-end gap-2 ii-bar-wrap">
                            @for (t of metrics.incidentTypeCounts; track t.incidentType) {
                                <div class="flex-fill text-center">
                                    <div class="ii-type-bar rounded-top" [style.height.px]="(t.count / maxTypeCount()) * 120 || 4" [title]="t.incidentType + ': ' + t.count"></div>
                                    <div class="small text-muted mt-1">{{ t.incidentType }}</div>
                                    <div class="small fw-semibold">{{ t.count }}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Top jobs (YTD)</h5>
                    <p class="small text-muted">Jobs with the most submitted incidents this year.</p>
                    @if (metrics.topJobs.length === 0) {
                        <p class="text-muted small mb-0">No job data recorded yet.</p>
                    } @else {
                        <ul class="list-unstyled mb-0">
                            @for (job of metrics.topJobs; track job.jobNumber) {
                                <li class="d-flex justify-content-between border-bottom py-1">
                                    <span class="text-truncate me-2">{{ job.jobNumber }}</span>
                                    <span class="fw-semibold">{{ job.count }}</span>
                                </li>
                            }
                        </ul>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
